import React, { useEffect, useState } from 'react'

export default function StampImageCard(props) {
  const { data } = props;
  const [srcDoc, setSrcDoc] = useState("");

  useEffect(() => {
    if (data.stamp_url.includes(".html")) {
      fetch(data.stamp_url)
      .then(response => response.text())
      .then(htmlContent => {
        setSrcDoc(htmlContent);
      })
      .catch(error => {
        console.error('Error fetching stamp HTML:', error);
      });
    }
  })
  return (
    <div className="relative w-full sm:h-[450px] h-[300px]">
      {
        data.stamp_url.includes(".html") ? 
        <iframe 
          srcDoc={srcDoc}
          className="w-full h-full object-contain rounded-md cursor-pointer"
          onClick={() => handleImageClick(data.stamp_url)}
          sandbox="allow-scripts allow-same-origin"
        />
        :
        <img
          src={data.stamp_url}
          alt="Stamp"
          onClick={() => handleImageClick(data.stamp_url)}
          className="w-full h-full object-contain rounded-md image-rendering-pixelated cursor-pointer"
        />
      }
    </div>
  )
}
